import { Real } from "@siteimprove/alfa-math";
import { Number, Percentage } from "../numeric/index.js";
import { Value } from "../value.js";
/**
 * @remarks
 * While colors can be calculated, they only use numbers and raw percentages.
 * Therefore, the calculations can be fully resolved at parse time and do not
 * need to be stored.
 *
 * @internal
 */
export class Format extends Value {
    _format;
    constructor(format) {
        super("color", false);
        this._format = format;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            format: this._format,
        };
    }
}
/**
 * @internal
 */
(function (Format) {
    function toPercentage(channel, max) {
        return Percentage.of(Real.clamp(channel.value / (Number.isNumber(channel) ? max : 1), 0, 1));
    }
    /**
     * {@link https://drafts.csswg.org/css-color/#resolving-color-values}
     */
    function resolve(red, green, blue, alpha) {
        return [
            toPercentage(red, 0xff),
            toPercentage(green, 0xff),
            toPercentage(blue, 0xff),
            toPercentage(alpha, 1),
        ];
    }
    Format.resolve = resolve;
})(Format || (Format = {}));
//# sourceMappingURL=format.js.map